<template>
  <div>
    <nav class="bar bar-nav">
      <h1 class="title">激活</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-name"></i></div>
              <div class="item-inner">
                <div class="item-title label">手机或邮箱</div>
                <div class="item-input">
                  <input type="text" v-model.trim="account" placeholder="帐号">
                </div>
              </div>
            </div>
          </li>
          <li v-show="type === 'phone'">
            <div class="item-content">
              <div class="item-media"><i class="icon icon-form-password"></i></div>
              <div class="item-inner">
                <div class="item-title label">验证码</div>
                <div class="item-input">
                  <input style="width:6rem;display: inline;" type="text" v-model.trim="veriCode" placeholder="验证码">
                  <div style="display: inline;width: 2.5rem">
                    <a @click="sendVeriCode" id="btn">发送</a>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div v-if="type === 'phone'" class="col-100"><a @click="submit" class="button button-big button-fill button-success">激活</a></div>
          <div v-if="type === 'email'" class="col-100"><a @click="sendEmail" class="button button-big button-fill button-success">发送激活邮件</a></div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import $ from 'jquery'

  export default {
    mounted () {
    },
    created () {
    },
    data () {
      return {
        account: '',
        type: 'phone',
        veriCode: '',
        coolDown: false
      }
    },
    watch: {
      'account': function (val) {
        var _this = this
        if (val.indexOf('@') !== -1) {
          _this.type = 'email'
        } else {
          _this.type = 'phone'
        }
      }
    },
    methods: {
      sendVeriCode () {
        let _this = this
        if (!_this.coolDown) {
          _this.gcapi('gcwwwifc/requestActivation', {'LoginId': _this.account})
            .then((response) => {
              _this.coolDown = true
              time(document.getElementById('btn'))
              $.toast(response.body['message'])
            }, (response) => {
              $.toast(response.body['message'])
            })
        }
        let wait = 60
        function time (o) {
          if (wait === 0) {
            _this.coolDown = false
            o.innerHTML = '发送'
            o.style.color = ''
            wait = 60
          } else {
            o.innerHTML = wait + 's'
            o.style.color = '#C8C8C8'
            wait--
            setTimeout(function () {
              time(o)
            }, 1000)
          }
        }
      },
      sendEmail () {
        let _this = this
        _this.gcapi('gcwwwifc/requestActivation', {'LoginId': _this.account})
          .then((response) => {
            if (response.body.code === 0) {
              $.toast(response.body.message)
              _this.$router.push('/me/login')
            } else {
              $.toast(response.body.message)
            }
          }, (response) => {
            $.toast(response.body.message)
          })
      },
      submit () {
        let _this = this
        _this.gcapi('gcwwwifc/activateCustomer', {'LoginId': _this.account, 'VerifyCode': _this.veriCode})
          .then((response) => {
            if (response.body.code === 0) {
              $.toast(response.body['message'])
              _this.$router.push('/login')
            } else {
              $.toast(response.body['message'])
            }
          }, (response) => {
            $.toast(response.body['message'])
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Activation.vue?e2c3b4f0